import { render, staticRenderFns, recyclableRender, components } from "./u-mask.vue?vue&type=template&id=7775dba7&scoped=true&"
var renderjs
import script from "./u-mask.vue?vue&type=script&lang=js&"
export * from "./u-mask.vue?vue&type=script&lang=js&"
import style0 from "./u-mask.vue?vue&type=style&index=0&id=7775dba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7775dba7",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-mask/u-mask.vue"
export default component.exports